import type { IconSvgObject } from './types';

const SolidLine01Icon: IconSvgObject = [
  ["path", { d: "M3 12L20 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SolidLine01Icon;
